import store from '@/store';
import statusCodes from '@/constants/statusCodes';

export const baseUrl = process.env.VUE_APP_API_URL;

export const urlVersionMatcher = /^\/v\d[0-9.]*\//;

export const INITIAL_API_VERSION = '1.0';

export const DEFAULT_MAX_RETRIES = 2;
export const DEFAULT_RETRY_INTERVAL = 5000;

export function appendUrlInitialVersion(url) {
  return `/v${
    INITIAL_API_VERSION
  }${
    url.startsWith('/') ? '' : '/'
  }${
    url
  }`;
}

/**
 * Verifica se uma resposta de erro de Http é repetível caso for baseado em erro genérico de serviço
 * ou infraestrutura.
 * @param {Object} response Resposta Http do axios.
 * @returns {Boolean} True, caso a resposta indique que é possível tentar uma nova repetição.
 */
export function isRetryableResponse(response = {}) {
  return (response.status >= statusCodes.INTERNAL_SERVER_ERROR && response.status < 600)
    || response.status === statusCodes.TOO_MANY_REQUESTS
    || response.status === statusCodes.UNAUTHORIZED;
}

/**
 * Decora um objeto de cabeçalho com configurações básicas do Sigma4Web, como autenticação e idioma.
 * @param {Object} [headers={}] Objeto de cabeçalhos. Se não for informado, cria um cabeçalho vazio.
 * @returns {Object}
 */
export function decorateBasicHeaders(headers) {
  const newHeaders = headers || {};
  if (store.getters.authenticated) {
    newHeaders.Authorization = `Bearer ${store.getters.token}`;
  }

  if (store.getters.language) {
    newHeaders['Accept-Language'] = store.getters.language.key;
  }

  return newHeaders;
}
